import './config'
import Vue from 'vue'
import '@/shared'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import './assets/css/overallSituation.less'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css'
import './components/common/directives'
import 'babel-polyfill'
import store from './store'
import '@/style/index.scss'
import Contextmenu from 'vue-contextmenujs'
import { userLoginInfo } from '@/apiUtils'
Vue.use(Contextmenu)

Vue.config.productionTip = false
// Vue.config.devtools = false
Vue.use(ElementUI, {
	size: 'small'
})

// 当为子窗口
const isChildWindow = window.opener && window.opener !== window
if (isChildWindow) {
	;(async function () {
		const info = await userLoginInfo()
		if (info.code !== 0) {
			return
		}
		if (process.env.NODE_ENV === 'development') {
			window.opener.postMessage({ type: 'self', Token: sessionStorage.getItem('Token') }, '*')
		} else {
			window.opener.postMessage({ type: 'self', Token: sessionStorage.getItem('Token') }, window.origin)
		}
		window.close()
	})()
}

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')
